import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ScrollToAnchorDirective } from '../../directives/anchors/scroll-to-anchor.directive';
import { IPageAnchor } from '../../models';


@Component({
	selector: 'page-anchors',
	templateUrl: './page-anchors.component.html',
	styles: `
        /* Bug 38950 icône de téléchargement n'est pas cliquable */
        .page-anchors-item:first-child {
            height: 1px;
            overflow: visible;
        }
    `,
	imports: [CommonModule, ScrollToAnchorDirective, NgbTooltipModule, TranslateModule]
})
export class PageAnchorsComponent {
	anchors = input<IPageAnchor[]>([])
}
